import React, { useState, useEffect } from 'react';
import './style.css';

const FULL_TEXT = "Hey! It's Suvi";
const PLAIN_PART = "Hey! It's ";
const TYPE_SPEED = 75;
const START_DELAY = 300;
const ANIM_RANGE = 0.5;

interface Props {
  scrollY: number;
}

const IntroAnimation: React.FC<Props> = ({ scrollY }) => {
  const [typed, setTyped] = useState(0);
  const [caretVisible, setCaretVisible] = useState(true);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setStarted(true), START_DELAY);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!started || typed >= FULL_TEXT.length) return;
    const t = setTimeout(() => setTyped(n => n + 1), TYPE_SPEED);
    return () => clearTimeout(t);
  }, [typed, started]);

  useEffect(() => {
    const interval = setInterval(() => setCaretVisible(v => !v), 530);
    return () => clearInterval(interval);
  }, []);

  const progress = Math.min(scrollY / (window.innerHeight * ANIM_RANGE), 1);
  const isSettled = progress > 0.95;

  const isMobile = window.innerWidth <= 1024;

  const topVh = 50 * (1 - progress);
  const topPx = 20 * progress;
  const leftVw = 50 * (1 - progress);
  const settledLeftPx = isMobile ? 16 : 48;
  const leftPx = settledLeftPx * progress;
  const translateXPct = -50 * (1 - progress);
  const fontSize = 120 - 102 * progress;
  const verticalOffset = (isMobile ? 1.8 : 0.5) * fontSize * (1 - progress);

  const paddingLeft = isMobile ? 50 * (1 - progress) : 0;

  const heroStyle = {
    top: `calc(${topVh}vh + ${topPx}px - ${verticalOffset}px)`,
    left: `calc(${leftVw}vw + ${leftPx}px)`,
    transform: `translateX(${translateXPct}%)`,
    paddingLeft: `${paddingLeft}px`,
    fontSize: `${fontSize}px`,
    '--hero-font-size': `${fontSize}px`,
  } as React.CSSProperties;

  const plainTyped = FULL_TEXT.slice(0, Math.min(typed, PLAIN_PART.length));
  const gradTyped = typed > PLAIN_PART.length ? FULL_TEXT.slice(PLAIN_PART.length, typed) : '';

  return (
    <>
      <div className="hero-text" style={heroStyle}>
        <span className="hero-plain">{plainTyped}</span>
        {gradTyped && <span className="hero-grad">{gradTyped}</span>}
        {!isSettled && (
          <span className={`hero-caret${caretVisible ? ' hero-caret-visible' : ''}`}>|</span>
        )}
      </div>
      <div className="hero-spacer" />
    </>
  );
};

export default IntroAnimation;
